export default {
    cms: {
        endpoint: 'http://cms.gladwellacademy.test/graphql'
    },
    api: {
        endpoint: 'https://api.gladwellacademy.test'
    }
};
